import React, { Component } from 'react';
import classNames from 'classnames/bind';
import styles from './ReviewModalMobile.scss';
import ReviewBox from '../common/ReviewBox';
import CustomScrollbar from 'web/components/common/CustomScrollbar';

const cx = classNames.bind(styles);

class ReviewModalMobile extends Component {
  goNext = () => {
    const { list = [], idx = 0 } = this.props;
    const { length } = list;

    let index = idx + 1;
    if (index > length - 1) {
      index = 0;
    }
    this.props.setIdx(index);
  };

  goPrev = () => {
    const { list = [], idx = 0 } = this.props;
    const { length } = list;

    // console.log({ idx, length });
    let index = idx - 1;
    if (idx <= 0) {
      index = length - 1;
    }
    this.props.setIdx(index);
  };

  render() {
    const { list = [], idx = 0, handleClose } = this.props;
    const data = list[idx];

    console.log('modal contents');

    return (
      <div className={cx('ReviewModalMobile')}>
        <div className={`review-content-wrap`}>
          <div>
            <span className="close" onClick={handleClose} />
          </div>
          <div className={`review-img`}>
            <img src={data.contentsUrl} alt={data.nickname} />
          </div>

          <div className={`review-content`}>
            {/* <CustomScrollbar right={'-10px'}> */}
            <ReviewBox type={`small`} star={data.scoreRate} />
            <div className="info">
              <span className="name">{data.nickname} | </span>
              <span className="date">{data.regDateAsString}</span>
            </div>
            <div className="content">
              {/* <CustomScroll right={'-10px'}> */}
              <p>{data.message}</p>
              {/* </CustomScroll> */}
            </div>
            {/* </CustomScrollbar> */}
          </div>
          <div className="btn-box">
            <div className="next-btn">
              <span onClick={this.goNext} />
            </div>

            <div className="prev-btn">
              <span onClick={this.goPrev} />
            </div>
            <div className="page">
              <span className="page-idx">{idx + 1} / </span>
              <span className="page-total">{list.length}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReviewModalMobile;
